<ng-container>
  <form (ngSubmit)="onSubmit()" *ngIf="examFilter" [formGroup]="examFilter" id="idFormFilter" name="formFilter"
    style="height: 100%; display: flex; flex-direction: column;">
    <div class="p-fluid">
      <div class="p-grid">
        <div class="p-col-12">
          <h3>Filtros</h3>
        </div>
      </div>
    </div>

    <div class="p-fluid" style="flex: 1; overflow-y: auto; overflow-x: hidden;">
      <div class="p-grid">
        <div class="p-col-12">
          <strong *ngIf="tipo==='periodicos' || tipo==='reevaluacion'">Vigencia en días hábiles</strong>
          <strong *ngIf="tipo==='porEnviar'">Tipo de Examen</strong>
        </div>
      </div>
      <div class="p-grid" *ngIf="tipo==='periodicos'">
        <div class="p-col-12">
          <div class="p-field-checkbox">
            <p-checkbox [formControl]="examFilter.controls['labelVigencia']" inputId="ny" name="group1"
              value="Menor a 30 días"></p-checkbox>
            <label>Menor a 30 días </label>
          </div>
          <div class="p-field-checkbox">
            <p-checkbox [formControl]="examFilter.controls['labelVigencia']" inputId="sf" name="group1"
              value="De 31 a 45 días">
            </p-checkbox>
            <label>De 31 a 45 días </label>
          </div>
          <div class="p-field-checkbox">
            <p-checkbox [formControl]="examFilter.controls['labelVigencia']" inputId="la" name="group1"
              value="De 46 a 90 días">
            </p-checkbox>
            <label>De 46 a 90 días </label>
          </div>
          <div class="p-field-checkbox">
            <p-checkbox [formControl]="examFilter.controls['labelVigencia']" inputId="ch" name="group1"
              value="Mayor a 91 días"></p-checkbox>
            <label>Mayor a 91 días</label>
          </div>
        </div>
      </div>
      <div class="p-grid" *ngIf="tipo==='reevaluacion'">
        <div class="p-col-12">
          <div class="p-field-checkbox">
            <p-checkbox [formControl]="examFilter.controls['labelVigencia']" inputId="ny" name="group1"
              value="Menor a 12 días"></p-checkbox>
            <label>Menor a 12 días </label>
          </div>
          <div class="p-field-checkbox">
            <p-checkbox [formControl]="examFilter.controls['labelVigencia']" inputId="sf" name="group1"
              value="De 12 a 20 días">
            </p-checkbox>
            <label>De 12 a 20 días </label>
          </div>
          <div class="p-field-checkbox">
            <p-checkbox [formControl]="examFilter.controls['labelVigencia']" inputId="la" name="group1"
              value="De 21 a 30 días">
            </p-checkbox>
            <label>De 21 a 30 días </label>
          </div>
          <div class="p-field-checkbox">
            <p-checkbox [formControl]="examFilter.controls['labelVigencia']" inputId="ch" name="group1"
              value="Mayor a 31 días"></p-checkbox>
            <label>Mayor a 31 días</label>
          </div>
        </div>
      </div>
      <div class="p-grid" *ngIf="tipo==='porEnviar'">
        <div class="p-col-12">
          <div class="p-field-checkbox">
            <p-checkbox [formControl]="examFilter.controls['labelExamen']" inputId="ny" name="group1"
              value="Periódico">
            </p-checkbox>
            <label>Periódicos</label>
          </div>
          <div class="p-field-checkbox">
            <p-checkbox [formControl]="examFilter.controls['labelExamen']" inputId="sf" name="group1"
              value="Reconfirmación">
            </p-checkbox>
            <label>Reconfirmación</label>
          </div>
        </div>
      </div>
      <div class="p-grid" *ngIf="tipo != 'cargados'">
        <div class="p-field p-col-12">
          <label>
            <strong *ngIf="tipo==='periodicos' || tipo==='reevaluacion'">Estudio</strong>
            <strong *ngIf="tipo==='porEnviar'">Estudio</strong>
            <strong> </strong>
          </label>
          <p-dropdown [showClear]="true" [options]="isOnline ? nombresExamen : tiposExamen" [resetFilterOnHide]="true"
            optionLabel="descripcion" optionValue="codigo" filter="filter" formControlName="tipoEstudio" id="localid"
            name="localid" placeholder="Seleccione" emptyFilterMessage="No hay resultados">
          </p-dropdown>
        </div>
      </div>
      <div class="p-grid" *ngIf="tipo != 'cargados'">
        <div class="p-field p-col-12">
          <label><strong>Nº de Lote </strong></label>
          <p-inputNumber formControlName="numeroLote" id="numeroCarpeta" name="numeroCarpeta" type="text" pKeyFilter="num"
          [useGrouping]="false" maxlength="19" max="9223372036854775807"></p-inputNumber>
        </div>
      </div>
      <div class="p-grid" *ngIf="tipo != 'cargados'">
        <div class="p-field p-col-12">
          <label><strong>Nº de Carpeta </strong></label>
          <p-inputNumber formControlName="numeroCarpeta" id="numeroCarpeta" name="numeroCarpeta" type="text" pKeyFilter="num"
          [useGrouping]="false" maxlength="19" max="9223372036854775807"></p-inputNumber>
        </div>
      </div>
      <div class="p-grid" *ngIf="tipo != 'cargados'">
        <div class="p-field p-col-12">
          <label>
            <strong>Tipo de documento</strong>
            <strong> </strong>
          </label>
          <p-dropdown [showClear]="true" [options]="tipoDocumentoTrabajador" optionLabel="descripcion" optionValue="codigo"
            [resetFilterOnHide]="true" filter="filter" formControlName="tipoDocumentoTrabajador"
            id="tipoDocumentoTrabajador" name="tipoDocumentoTrabajador" placeholder="Seleccione"
            emptyFilterMessage="No hay resultados" [appendTo]="'body'"></p-dropdown>
        </div>
      </div>
      <div class="p-grid" *ngIf="tipo != 'cargados'">
        <div class="p-field p-col-12">
          <label><strong>Nº de Documento </strong></label>
          <p-inputNumber formControlName="nroDocumentoTrabajador" id="nroDocumentoTrabajador" name="nroDocumentoTrabajador"
          [useGrouping]="false" type="text" pKeyFilter="num" maxlength="10" max="2147483647"></p-inputNumber>
        </div>
      </div>

      <ng-container *ngIf="tipo === 'cargados'">

        <div class="p-grid">
          <div class="p-field p-col-12">
            <label><strong>Fecha de Carga</strong></label>
            <p-calendar #fechaCarga [(ngModel)]="date" [showIcon]="true" [showClear]="true" dataType="date" dateFormat="dd/mm/yy"
              placeholder="dd/mm/yyyy" id="fechaCarga" (ngModelChange)="disableFields($event, fechaCarga)" [yearRange]="yearRange" [yearNavigator]="true" [monthNavigator]="true"
              inputId="fechaCarga" name="fechaCarga" formControlName="fechaCarga" [disabled]="estado == 'enviado'">
            </p-calendar>
            <app-invalid-from-message *ngIf="errorMessage" [message]=errorMessage></app-invalid-from-message>
          </div>
        </div>
      
        <div class="p-grid">
          <div class="p-field p-col-12">
            <button pButton type="button" label="Exportar Resultados" icon="pi pi-file" (click)="obtenerDatos()" [disabled]="!botonHabilitado"></button>
          </div>
        </div>
        
        <div class="p-grid">
          <div class="p-field p-col-12">
            <label><strong>Empresa - CUIT</strong></label>
            <input formControlName="empresaCuit" id="empresaCuit" name="cuit" pInputText type="text" pKeyFilter="num"
              numberDirective maxlength="20" [maximo]="0" />
          </div>
        </div>

        <div class="p-grid">
          <div class="p-field p-col-12">
            <label><strong>Empresa - Razón Social</strong></label>
            <input formControlName="empresaRazonSocial" id="empresa" name="empresa" pInputText type="text" />
          </div>
        </div>

        <div class="p-grid">
          <div class="p-field p-col-12">
            <label><strong>Nº de Lote</strong></label>
            <p-inputNumber formControlName="numeroLote" id="numeroLote" name="numeroLote" type="text" pKeyFilter="num"
            [useGrouping]="false" maxlength="19" max="9223372036854775807"></p-inputNumber>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-field p-col-12">
            <label><strong>Nº de Carpeta </strong></label>
            <p-inputNumber formControlName="numeroCarpeta" id="numeroCarpeta" name="numeroCarpeta" type="text" pKeyFilter="num"
            [useGrouping]="false" maxlength="19" max="9223372036854775807"></p-inputNumber>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-field p-col-12">
            <label>
              <strong>Tipo de documento</strong>
              <strong> </strong>
            </label>
            <p-dropdown [showClear]="true" [options]="tipoDocumentoTrabajador" optionLabel="descripcion" optionValue="codigo"
              [resetFilterOnHide]="true" filter="filter" formControlName="tipoDocumentoTrabajador"
              id="tipoDocumentoTrabajador" name="tipoDocumentoTrabajador" placeholder="Seleccione"
              emptyFilterMessage="No hay resultados"></p-dropdown>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-field p-col-12">
            <label><strong>Nº de Documento </strong></label>
            <p-inputNumber formControlName="nroDocumentoTrabajador" id="nroDocumentoTrabajador" name="nroDocumentoTrabajador"
            [useGrouping]="false" type="text" pKeyFilter="num" maxlength="10" max="2147483647" ></p-inputNumber>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-field p-col-12">
            <label>
              <strong>Estudio</strong>
              <strong> </strong>
            </label>
            <p-dropdown [showClear]="true" [options]="nombresExamen" optionLabel="descripcion" optionValue="codigo"
              [resetFilterOnHide]="true" filter="filter" formControlName="nombreExamen" id="nombreExamen"
              name="nombreExamen" placeholder="Seleccione" emptyFilterMessage="No hay resultados"></p-dropdown>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-field p-col-12">
            <label>
              <strong>Tipo de Estudio</strong>
              <strong> </strong>
            </label>
            <p-dropdown [showClear]="true" [options]="tiposExamenFilter" optionLabel="descripcion" optionValue="descripcion"
              [resetFilterOnHide]="true" filter="filter" formControlName="tipoExamen" id="tipoExamen" name="tipoExamen"
              placeholder="Seleccione" emptyFilterMessage="No hay resultados" [appendTo]="'body'"></p-dropdown>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-field p-col-12">
            <label>
              <strong>Tipo de Dictamen</strong>
              <strong> </strong>
            </label>
            <p-dropdown [showClear]="true" [options]="tiposDictamen" optionLabel="descripcion" optionValue="codigo"
              [resetFilterOnHide]="true" filter="filter" formControlName="tipoDictamen" id="tipoDictamen"
              name="tipoDictamen" placeholder="Seleccione" emptyFilterMessage="No hay resultados"></p-dropdown>
          </div>
        </div>

      </ng-container>

    </div>

    <div class="p-fluid">
      <div class="p-grid">
        <div class="p-col-12">
          <button label="Aplicar filtros" pButton type="submit" [disabled]="!checkEnabledButton()">
          </button>

          <button (click)="clearFilter()" class="p-button-text" label="Limpiar filtros" pButton type="button"
            [disabled]="!checkClearFilterButtonEnabled()">
          </button>
        </div>
      </div>
    </div>
  </form>
</ng-container>